module.exports = __webpack_public_path__ + "img/pingjia1.e08bcb07.png";